// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-jt {\n  color: #e40000;\n}\n.color-blue {\n  color: #0054f0;\n}\n.bg-color-jt {\n  background: #e40000;\n}\n.bg-color-blue {\n  background: #0054f0;\n}\n.mt-0 {\n  margin-top: 0;\n}\n.mt-19 {\n  margin-top: 19px;\n}\n.mr-25 {\n  margin-right: 25px;\n}\n.weigh-700 {\n  font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
